import type { TaskExecution } from '@/types/taskPlatform';

export function publicationTaskState(task: TaskExecution) {
  if (task.mainOutcome === 'succeeded') {
    if (task.deliveryStatus === 'failed') return 'notificationFailed';
    if (
      task.deliveryStatus === 'succeeded' &&
      task.executionStatus === 'SUCCEEDED'
    )
      return 'ready';
    return 'confirming';
  }
  if (
    task.mainOutcome === 'failed' ||
    ['FAILED', 'TIMED_OUT', 'ABORTED'].includes(task.executionStatus)
  )
    return 'failed';
  if (!task.sourceAvailable || task.executionStatus === 'unknown')
    return 'unknown';
  return 'preparing';
}
